module.exports = __webpack_public_path__ + "img/icon-new-lab-manager.1d84ec29.svg";